@if (profilesLoaded) {
  <div class="popup-container">
    <div class="popup-header">
      <div>
        <h2 class="popup-title">Ajuster le planning</h2>
        <p class="popup-subtitle">Gagner du temps en ajustant et optimisant le planning selon vos besoins.</p>
      </div>
    </div>

    <div class="popup-body" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="16px">
      <div fxFlex="50%" class="body" fxLayout="column" fxLayoutAlign="start stretch">
        <div class="popup-content">
          <div
            class="section configuration-section config-details-section"
            [class.no-border]="selectedConfigId === 'new'"
          >
            <div class="section-header">
              <div class="section-info">
                <h3 class="section-title">Configurations enregistrées</h3>
                <p class="section-description">Sélectionnez une configuration précédente ou créez-en une nouvelle</p>
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Charger une configuration</label>
              <div class="default-select">
                <div class="select-container">
                  <select [(ngModel)]="selectedConfigId" (change)="onConfigurationSelect(selectedConfigId)">
                    <option fxLayout="row" fxLayoutAlign="space-between center" [ngValue]="'new'">
                      -- Nouvelle configuration --
                    </option>
                    @for (config of savedConfigurations; track config._id) {
                      <option [ngValue]="config._id" fxLayout="row" fxLayoutAlign="space-between center">
                        {{ config.name }} ({{ config.createdAt | date: 'dd/MM/yyyy' }})
                      </option>
                    }
                  </select>
                </div>
              </div>

              @if (selectedConfigId === 'new') {
                <div class="name-input-container">
                  <p class="name-description">Titre <span style="color: red">*</span></p>
                  <app-text-input
                    llabel=""
                    type="text"
                    [(ngModel)]="configurationName"
                    (ngModelChange)="checkDuplicateName()"
                    class="name-input"
                  ></app-text-input>
                  @if (isDuplicateName) {
                    <p class="error-message" style="color: red">Ce nom existe déjà. Veuillez choisir un autre nom.</p>
                  }
                </div>
              }
            </div>
            @if (selectedConfigId === 'new') {
              <div style="margin-top: 16px">
                <app-checkbox-group
                  label="Postes"
                  layout="row wrap"
                  [elements]="positions"
                  [(ngModel)]="selectedPositions"
                  (selectionChange)="onPositionsChange($event)"
                  style="min-height: 80px; height: fit-content"
                ></app-checkbox-group>
              </div>
            }
            @if (selectedConfigId !== 'new' && selectedConfigId) {
              <div class="config-detail-row">
                <mat-icon class="detail-icon">calendar_today</mat-icon>
                <span class="detail-text position-badge"
                  >{{ formatedStartDate | date: 'dd/MM/yyyy' }} - {{ formatedEndDate | date: 'dd/MM/yyyy' }}</span
                >
              </div>

              <div class="config-detail-row">
                <mat-icon class="detail-icon">person</mat-icon>
                <div class="detail-badges">
                  @for (position of selectedPositions; track position) {
                    <span class="position-badge">{{ position.label }}</span>
                  }
                </div>
              </div>

              <div class="config-detail-row" [class.inactive]="!reasonsMapsExchange">
                <mat-icon class="detail-icon" [class.inactive-icon]="!reasonsMapsExchange">swap_horiz</mat-icon>
                <span class="detail-text position-badge" [class.inactive-badge]="!reasonsMapsExchange">{{
                  'Echange jour de repos et code horaire hebdomadaire'
                }}</span>
              </div>

              @if (reasonsMapsExchange) {
                <div class="config-detail-subrow" [class.inactive-subrow]="!keepRestDaysIntact">
                  <mat-icon class="detail-icon-small" [class.inactive-icon-small]="!keepRestDaysIntact"
                    >subdirectory_arrow_right</mat-icon
                  >
                  <span class="detail-subtext position-badge" [class.inactive-badge]="!keepRestDaysIntact">
                    {{ keepRestDaysIntact ? 'Conserver les jours de repos' : 'Ne pas conserver les jours de repos' }}
                  </span>
                </div>
              }

              <div class="config-detail-row" [class.inactive]="!allowOvertimeHours">
                <mat-icon class="detail-icon" [class.inactive-icon]="!allowOvertimeHours">schedule</mat-icon>
                <span class="detail-text position-badge" [class.inactive-badge]="!allowOvertimeHours"
                  >Heures supplémentaires</span
                >
              </div>

              @if (allowOvertimeHours) {
                <div class="config-detail-subrow">
                  <mat-icon class="detail-icon-small">subdirectory_arrow_right</mat-icon>
                  <span class="detail-subtext position-badge">
                    {{ maxOvertimeHours }}h
                    {{ maxOvertimeMinutes !== 0 ? maxOvertimeMinutes + 'min' : '' }}
                    max. d'heures supplémentaires autorisées par profil
                  </span>
                </div>
              }

              <div class="config-detail-row" [class.inactive]="!callVacataires">
                <mat-icon class="detail-icon" [class.inactive-icon]="!callVacataires">groups</mat-icon>
                <span class="detail-text position-badge" [class.inactive-badge]="!callVacataires">{{
                  callVacataires ? 'Faire appel aux vacataires' : 'Ne pas faire appel aux vacataires'
                }}</span>
              </div>
            }
          </div>

          @if (selectedConfigId !== 'new' && selectedConfigId) {
            <div class="section statistics-section">
              <div class="section-header">
                <div class="section-info">
                  <h3 class="section-title">Statistiques</h3>
                  <p class="section-description">Aperçu des indicateurs clés sur la période du planning</p>
                </div>
              </div>

              <div class="stats-grid">
                <div
                  class="stat-card-wrapper"
                  (mouseenter)="!isOvertimeLocked && (showOvertimeTooltip = true)"
                  (mouseleave)="!isOvertimeLocked && (showOvertimeTooltip = false)"
                  (click)="toggleTooltip('overtime', $event)"
                >
                  <div class="stat-card stat-card-with-tooltip">
                    <div class="stat-value">
                      {{ PlanningTuningStatsData ? convertHoursToHM(PlanningTuningStatsData.totalOvertime) : '0h' }}
                    </div>
                    <div class="stat-label">Heures Supp. Totales</div>
                  </div>

                  <div class="custom-tooltip" [class.visible]="showOvertimeTooltip">
                    <div class="tooltip-arrow"></div>
                    <div class="tooltip-content">
                      <div class="tooltip-header">
                        <span>Heures Supplémentaires par Profil</span>
                      </div>
                      <div class="tooltip-profiles">
                        @if (profilsWithOverTime && profilsWithOverTime.length > 0) {
                          @for (profile of profilsWithOverTime; track profile.profile) {
                            <div class="profile-row">
                              <app-smart-op-avatar
                                [hoverHighlight]="false"
                                [profile]="profile.profile"
                                class="profile-avatar"
                              ></app-smart-op-avatar>

                              <div class="profile-hours">{{ convertHoursToHM(profile.timeExtension) }}</div>
                            </div>
                          }
                        } @else {
                          <div class="no-data">Aucune donnée disponible</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div class="stat-card-wrapper" (click)="toggleTooltip('exchange', $event)">
                  <div class="stat-card stat-card-with-tooltip">
                    <div class="stat-value">
                      {{ PlanningTuningStatsData ? PlanningTuningStatsData.nbEchangesTotal : 0 }}
                    </div>
                    <div class="stat-label">Total des Echanges</div>
                  </div>

                  <div class="custom-tooltip" [class.visible]="showExchangeTooltip">
                    <div class="tooltip-arrow"></div>
                    <div class="tooltip-content">
                      <div class="tooltip-header">
                        <span>Nombre d'échanges par Profil</span>
                      </div>
                      <div class="tooltip-profiles">
                        @if (profilsWithExchanges && profilsWithExchanges.length > 0 && nbEchanges > 0) {
                          @for (profile of profilsWithExchanges; track profile.profile) {
                            <div class="profile-row">
                              <app-smart-op-avatar
                                [hoverHighlight]="false"
                                [profile]="profile.profile"
                                class="profile-avatar"
                              ></app-smart-op-avatar>

                              <div class="profile-hours">{{ profile.nbEchanges }}</div>
                            </div>
                          }
                        } @else {
                          <div class="no-data">Aucune donnée disponible</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div class="stat-card-wrapper" (click)="toggleTooltip('reasonsMaps', $event)">
                  <div class="stat-card stat-card-with-tooltip">
                    <div class="stat-value">
                      {{
                        PlanningTuningStatsData && PlanningTuningStatsData.initialCoverageRate
                          ? formatNumber(PlanningTuningStatsData.initialCoverageRate * 100)
                          : 0
                      }}%
                    </div>
                    <div class="stat-label">Taux de couverture avant ajustement</div>
                  </div>

                  <div class="custom-tooltip" [class.visible]="showReasonsMapsTooltip && !showReasonsMapsAfterTooltip">
                    <div class="tooltip-arrow"></div>
                    <div class="tooltip-content">
                      <div class="tooltip-header">
                        <span>Taux de couverture par code horaire</span>
                      </div>
                      <div class="tooltip-profiles">
                        @if (needsCoverage && needsCoverage.length > 0) {
                          @for (need of needsCoverage; track need.reasonMap) {
                            <div class="profile-row">
                              @if (need && need.reasonMap && need.reasonMap.code) {
                                <app-code-rh-badge
                                  [text]="need.reasonMap.code"
                                  [reasonMap]="need.reasonMap"
                                  [color]="need.reasonMap.color"
                                  [startTime]="(need.reasonMap.morningStartTime | date: 'HH:mm' : 'UTC') || ''"
                                  [endTime]="(need.reasonMap.afternoonEndTime | date: 'HH:mm' : 'UTC') || ''"
                                ></app-code-rh-badge>
                              }

                              <div class="profile-hours" [ngClass]="need.initial_coverage_mean >= 1 ? 'green' : 'red'">
                                {{ need.initial_coverage_mean ? formatNumber(need.initial_coverage_mean * 100) : 0 }}%
                              </div>
                            </div>
                          }
                        } @else {
                          <div class="no-data">Aucune donnée disponible</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div class="stat-card-wrapper" (click)="toggleTooltip('vacataires', $event)">
                  <div class="stat-card stat-card-with-tooltip">
                    <div class="stat-value">
                      {{ PlanningTuningStatsData ? PlanningTuningStatsData.nbTempWorkersRequested : 0 }}
                    </div>
                    <div class="stat-label">Nombres de vacations sollicitées</div>
                  </div>

                  <div class="custom-tooltip" [class.visible]="showVacatairesTooltip && !showVacatairesMoyTooltip">
                    <div class="tooltip-arrow"></div>
                    <div class="tooltip-content">
                      <div class="tooltip-header">
                        <span>Profils Vacataires</span>
                      </div>
                      <div class="tooltip-profiles">
                        @if (profilesWithHours && profilesWithHours.length > 0) {
                          @for (profile of profilesWithHours; track profile.profile) {
                            <div class="profile-row">
                              <app-smart-op-avatar
                                [hoverHighlight]="false"
                                [profile]="profile.profile"
                                class="profile-avatar"
                              ></app-smart-op-avatar>
                            </div>
                          }
                        } @else {
                          <div class="no-data">Aucune donnée disponible</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div class="stat-card-wrapper" (click)="toggleTooltip('vacatairesMoy', $event)">
                  <div class="stat-card stat-card-with-tooltip">
                    <div class="stat-value">
                      {{
                        PlanningTuningStatsData && PlanningTuningStatsData.nbConversionTotal
                          ? PlanningTuningStatsData.nbConversionTotal
                          : 0
                      }}
                    </div>
                    <div class="stat-label">Total des conversions</div>
                  </div>

                  <div class="custom-tooltip" [class.visible]="showVacatairesMoyTooltip">
                    <div class="tooltip-arrow"></div>
                    <div class="tooltip-content">
                      <div class="tooltip-header">
                        <span>Nombre de conversions par profil </span>
                      </div>
                      <div class="tooltip-profiles">
                        @if (profilsWithExchanges && profilsWithExchanges.length > 0 && nbConversions > 0) {
                          @for (profile of profilsWithExchanges; track profile.profile) {
                            <div class="profile-row">
                              <app-smart-op-avatar
                                [hoverHighlight]="false"
                                [profile]="profile.profile"
                                class="profile-avatar"
                              ></app-smart-op-avatar>

                              <div class="profile-hours">{{ profile.nbConversions }}</div>
                            </div>
                          }
                        } @else {
                          <div class="no-data">Aucune donnée disponible</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <div class="stat-card-wrapper" (click)="toggleTooltip('reasonsMapsAfter', $event)">
                  <div class="stat-card stat-card-with-tooltip highlight">
                    <div class="stat-value">
                      {{
                        PlanningTuningStatsData && PlanningTuningStatsData.finalCoverageRate
                          ? formatNumber(PlanningTuningStatsData.finalCoverageRate * 100)
                          : 0
                      }}%
                    </div>
                    <div class="stat-label">Taux de couverture aprés Ajustement</div>
                  </div>

                  <div class="custom-tooltip" [class.visible]="showReasonsMapsAfterTooltip">
                    <div class="tooltip-arrow"></div>
                    <div class="tooltip-content">
                      <div class="tooltip-header">
                        <span>Taux de couverture par code horaire</span>
                      </div>
                      <div class="tooltip-profiles">
                        @if (needsCoverage && needsCoverage.length > 0) {
                          @for (need of needsCoverage; track need.reasonMap) {
                            <div class="profile-row">
                              @if (need && need.reasonMap && need.reasonMap.code) {
                                <app-code-rh-badge
                                  [text]="need.reasonMap.code"
                                  [reasonMap]="need.reasonMap"
                                  [color]="need.reasonMap.color"
                                  [startTime]="(need.reasonMap.morningStartTime | date: 'HH:mm' : 'UTC') || ''"
                                  [endTime]="(need.reasonMap.afternoonEndTime | date: 'HH:mm' : 'UTC') || ''"
                                ></app-code-rh-badge>
                              }

                              <div class="profile-hours" [ngClass]="need.final_coverage_mean >= 1 ? 'green' : 'red'">
                                {{ need.final_coverage_mean ? formatNumber(need.final_coverage_mean * 100) : 0 }}%
                              </div>
                            </div>
                          }
                        } @else {
                          <div class="no-data">Aucune donnée disponible</div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (selectedConfigId === 'new') {
            <div class="section">
              <div class="section">
                <div class="section-header-toggle">
                  <div class="section-header-left">
                    <mat-icon class="section-icon">event</mat-icon>
                    <div class="section-info">
                      <h3 class="section-title">Echange jour de repos et code horaire hebdomadaire</h3>
                      <p class="section-description">Réorganise les plannings sans modifier le total d'heures.</p>
                    </div>
                  </div>
                  <mat-slide-toggle [(ngModel)]="reasonsMapsExchange" color="primary"></mat-slide-toggle>
                </div>
                @if (reasonsMapsExchange) {
                  <div class="section-header-toggle1">
                    <mat-checkbox [(ngModel)]="keepRestDaysIntact" color="primary">
                      <div class="section-info">
                        <h4 class="section-title1">Conserver les jours de repos</h4>
                        <p class="section-description1">
                          Échanger uniquement les codes horaires, sans modifier les jours de repos
                        </p>
                      </div>
                    </mat-checkbox>
                  </div>
                }

                <div class="form-group">
                  <label class="form-label">Période</label>
                  <app-range-date-picker
                    #datePicker
                    class="small-date-picker"
                    [showArrows]="false"
                    (SelectedDates)="onDateChange($event)"
                    [sideOpening]="'right'"
                    [startDay]="formatedStartDate"
                    [endDay]="formatedEndDate"
                    [hasDefaultRanges]="false"
                    [hasPastRanges]="false"
                    [minDate]="minDate"
                    [hasWeekRanges]="true"
                    [onlyWeeks]="true"
                  ></app-range-date-picker>
                </div>
              </div>

              <div class="section">
                <div class="section-header-toggle">
                  <div class="section-header-left">
                    <mat-icon class="section-icon">hourglass_empty</mat-icon>
                    <div class="section-info">
                      <h3 class="section-title">Heures supplémentaires</h3>
                      <p class="section-description">Autorise des ajustements en respectant la contrainte RH</p>
                    </div>
                  </div>
                  <mat-slide-toggle [(ngModel)]="allowOvertimeHours" color="primary"></mat-slide-toggle>
                </div>
                @if (allowOvertimeHours) {
                  <div class="overtime-input-container">
                    <app-text-input
                      label=""
                      type="number"
                      [showNumberButtons]="true"
                      [minNumber]="1"
                      [maxNumber]="10"
                      [(ngModel)]="maxOvertimeHours"
                      class="overtime-input"
                    ></app-text-input
                    >h
                    <app-text-input
                      label=""
                      type="number"
                      [showNumberButtons]="true"
                      [minNumber]="0"
                      [maxNumber]="59"
                      [(ngModel)]="maxOvertimeMinutes"
                      class="overtime-input"
                    ></app-text-input
                    >min
                    <p class="overtime-description">Nombre maximal d'heures supplémentaires autorisées par profil</p>
                  </div>
                }
              </div>

              <div class="section">
                <div class="section-header-toggle">
                  <div class="section-header-left">
                    <mat-icon class="section-icon">group</mat-icon>
                    <div class="section-info">
                      <h3 class="section-title">Appel aux vacataires</h3>
                      <p class="section-description">Ajoute du personnel externe si besoin</p>
                    </div>
                  </div>
                  <mat-slide-toggle [(ngModel)]="callVacataires" color="primary"></mat-slide-toggle>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div fxFlex="46%" class="body-profiles" fxLayout="column" fxLayoutAlign="start stretch">
        <app-text-input
          class="search-input"
          label="Rechercher une personne"
          placeholder="Rechercher une personne ..."
          icon="search"
          iconType="mat-icon"
          [(inputModel)]="searchValue"
          (keyup)="doFilterKeyUp($event)"
          ngDefaultControl
        ></app-text-input>
        <div class="profiles-box">
          <div *ngFor="let profile of profilesFormElements; let i = index" class="profile-box">
            <mat-checkbox
              (ngModelChange)="onProfilesSelectionChange($event, profile.value)"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="profile.isChecked"
            >
              {{ profile.label }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
    @if (!validate && selectedConfigId === 'new') {
      <div class="buttons" fxLayout="row" fxLayoutAlign="end center">
        <app-button (click)="closePopup()" btnType="text" text="Annuler"></app-button>
        <app-button
          (click)="saveConfiguration()"
          [isSpinner]="true"
          [disabled]="isAdjustButtonDisabled()"
          text="Ajuster"
        ></app-button>
      </div>
    } @else {
      <div class="buttons" fxLayout="row" fxLayoutAlign="end center">
        <app-button (click)="closePopup()" btnType="text" text="Annuler"></app-button>
        <app-button (click)="visualizePlanning()" [isSpinner]="true" btnType="outlined" text="Visualiser"></app-button>
        <app-button (click)="exportPlanning()" [isSpinner]="true" text="Exporter"></app-button>
        <app-button (click)="validatePlanning()" [isSpinner]="true" text="Valider"></app-button>
      </div>
    }
  </div>
} @else {
  <div class="loading-container" fxLayout="row" fxLayoutAlign="center center">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
}
